/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubMenuTab/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Children from 'Simple/Children'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function SubMenuTab({
  children,
  viewPath = "/DesignSystem/SubMenuTab",
  paddingLeft = 0,
  paddingRight = 32,
  paddingTop = 8,
  marginLeft = 0,
  onClick,
  innerRef,
  isSelected,
  colorActive,
  size = "large",
  color,
  text = "Tab name",
  hasDownArrow
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let colorActiveOrdtColorsGreen700 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7001 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7002 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7003 = colorActive ?? dtColorsGreen700
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let colorOrdtColorsNeutral600 = color ?? dtColorsNeutral600
let colorActiveOrdtColorsGreen7004 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7005 = colorActive ?? dtColorsGreen700
let colorOrdtColorsNeutral6001 = color ?? dtColorsNeutral600
let colorActiveOrdtColorsGreen7006 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7007 = colorActive ?? dtColorsGreen700
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let colorActiveOrdtColorsGreen7008 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7009 = colorActive ?? dtColorsGreen700
  return (<React.Fragment
>
<button
  data-testid="SubMenuTab.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 ref={innerRef}
 style={{'--pl-1-1IAWtm': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-2-1IAWtm': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-3-1IAWtm': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--ml-4-1IAWtm': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--c-5-1IAWtm': isSelected ? "default" : "pointer"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SubMenuTab.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 fill={isSelected ? colorActiveOrdtColorsGreen7003 : isHovered ? colorActiveOrdtColorsGreen7002 : dtColorsNeutral700}
 height={16}
 width={16}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 color={isSelected ? colorActiveOrdtColorsGreen7007 : isHovered ? colorActiveOrdtColorsGreen7006 : colorOrdtColorsNeutral6001}
 weight="medium"
 marginLeft={dtSpaceXxs}
 text={text}
/>
<fromFlow.When is={hasDownArrow}>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 fill={dtColorsNeutral700}
 height={16}
 width={16}
 marginLeft={dtSpaceXxs}
/>
</fromFlow.When>
</div>
<div
  data-testid="SubMenuTab.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-6-1IAWtm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-7-1IAWtm': isSelected ? colorActiveOrdtColorsGreen7009 : isHovered ? colorActiveOrdtColorsGreen7008 : "transparent"}}
 className={`views-block ${styles.Vertical1}`}
/>
</button>
</React.Fragment>)
}